import Login from '../views/Login'
import Signup from '../views/Signup'
import PasswordReset from '../views/PasswordReset'
import LoginAsUser from '../views/LoginAsUser';
import Constants from './Constants';

export default [
    {
        path : '/login',
        name : Constants.LOGIN,
        component : Login,
        meta : {
            title : 'Login',
            no_session : true,
            layout : 'NoLayout',
        }
    },
    {
        path : '/signup',
        name : Constants.SIGNUP,
        component : Signup,
        meta : {
            title : 'Signup',
            layout : 'NoLayout',
            no_session : true,
        },
    },
    {
        path : '/password-reset/:user_id/:token',
        name : Constants.PASSWORD_RESET,
        component : PasswordReset,
        meta : {
            title : 'Reset Your Password',
            layout : 'NoLayout',
            no_session : true,
        },
    },
    {
        path : '/set-token/:token',
        name : Constants.LOGIN_AS_USER,
        component : LoginAsUser,
        meta : {
            title : 'Logging In...',
            no_session : true,
            layout : 'NoLayout',
        }
    },
];
